import * as React from 'react'

import {
  SelectOptionProps,
  SelectField
} from '@espoon-voltti/react-components/elements/form'
import { Field, FieldProps } from 'formik'
import { ErrorMessage, fieldState } from '../formik-util'

interface Props {
  name: string
  label: React.ReactNode
  dataQa: string
  required?: boolean
  placeholder?: string
  disabled?: boolean
}

export const FormSelectField = (
  p: Props & { options: SelectOptionProps[] }
) => (
  <Field name={p.name}>
    {({ form, field }: FieldProps) => (
      <SelectField
        options={p.options}
        // name={p.name} // error TS2783: is specified more than once, so this usage will be overwritten.
        label={p.label}
        // value={field.value} // error TS2783: is specified more than once, so this usage will be overwritten.
        dataQa={p.dataQa}
        placeholder={p.placeholder}
        required={p.required}
        state={fieldState(field.name, form)}
        message={<ErrorMessage name={field.name} />}
        disabled={p.disabled}
        {...field}
      />
    )}
  </Field>
)
